import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";
import { api, formatApiError } from "@/lib/api";

export default function DocPreviewDialog({ doc, onOpenChange }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!doc) return undefined;
    let objectUrl;
    setUrl(null);
    setError("");
    api.get(`/kyc/documents/${doc.id}/file`, { responseType: "blob" })
      .then(({ data }) => { objectUrl = URL.createObjectURL(data); setUrl(objectUrl); })
      .catch((e) => setError(formatApiError(e)));
    return () => objectUrl && URL.revokeObjectURL(objectUrl);
  }, [doc]);

  return (
    <Dialog open={!!doc} onOpenChange={onOpenChange}>
      <DialogContent className="border-line bg-panel sm:max-w-3xl" data-testid="doc-preview-dialog">
        <DialogHeader><DialogTitle>{doc?.doc_type === "id" ? "Photo ID" : "Proof of address"} · {doc?.original_filename}</DialogTitle></DialogHeader>
        <div className="flex min-h-[300px] items-center justify-center overflow-hidden rounded-xl border border-line bg-obsidian">
          {!url && !error && <Loader2 className="h-6 w-6 animate-spin text-emerald-500" />}
          {error && <p className="text-sm text-red-400">{error}</p>}
          {url && (doc.content_type === "application/pdf"
            ? <iframe src={url} title="Document" className="h-[70vh] w-full" data-testid="doc-preview-pdf" />
            : <img src={url} alt="Document" className="max-h-[70vh] object-contain" data-testid="doc-preview-image" />)}
        </div>
      </DialogContent>
    </Dialog>
  );
}
